var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('Sidebar'), _c('div', {
    ref: "contentDiv",
    staticClass: "main-content",
    class: {
      'has-location-footer': _vm.locationId || _vm.locationGroupId
    },
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "id": "content"
    }
  }, [!_vm.isSidebarLoading ? [_c('div', {
    staticClass: "notifications-wrapper"
  }, [_c('div', {
    staticClass: "global-notification"
  }, [_vm.showMaintenanceNotification ? _c('div', {
    staticClass: "notification"
  }, [_vm._v(" " + _vm._s(_vm.maintenanceStatus.message) + " "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.dismissNotification.apply(null, arguments);
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]) : _vm._e()])]), _c('dash-header'), _c('div', {
    staticClass: "inner-content",
    staticStyle: {
      "overflow-x": "hidden",
      "overflow-y": "auto"
    }
  }, [_c('router-view')], 1), _vm.locationId || _vm.locationGroupId ? [_c('LocationFooterNav')] : _vm._e()] : _vm._e()], 2), _c('WeatherLocationModal')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }